module.exports = __webpack_public_path__ + "img/di_16_LowStock.f6b77711.png";